const overview_pt = require('./overview.json')
export default overview_pt